export default {
    indexPlaces:     { method: 'get',    url: 'places' },
    createPlace:     { method: 'post',   url: 'places'},
    updatePlace:     { method: 'put',    url: 'places/{id}'},
    destroyPlace:    { method: 'delete', url: 'places/{id}'},
}